<main class="signed-out" data-testid="signed-out-page">
  <puro-typography component="h1" variant="h2" class="signed-out__title">
    {{ 'layout.signedOut.title' | translate }}
  </puro-typography>
  <puro-typography component="p" variant="body1" class="signed-out__body">
    {{ 'layout.signedOut.body' | translate }}
  </puro-typography>
  <a class="signed-out__link" [href]="purolatorHomeUrl">
    {{ 'layout.signedOut.continue' | translate }}
  </a>
</main>
